/* eslint-disable no-return-assign */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../actions';
import * as c from '../constant';

function ViewESOA({
  data,
  getItem,
}) {
  const setModal = useContext(ModalContext);
  const [iframeKey, setIframeKey] = useState(1);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const src = `${process.env.REACT_APP_WS}${c.EBPLS_E2E_URL.replace(
    '{id}',
    _.get(data, 'id')
  )}?bearer_token=${token}&email=${_.get(authProfile, 'email')}&output=I`;

  useEffect(() => {
    setIframeKey(_.random(1, 1000));
    getItem(_.get(data, 'id'));
  }, []); // re-render on update cedula amount

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  key={iframeKey}
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Statement of Account"
                  src={src}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewESOA.defaultProps = {
};

ViewESOA.propTypes = {
  getItem: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => {
  return {
    item: get(api, `${c.ITEM}.item`) || {},
  };
};

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewESOA);
